var m = require('mithril');
var prop = require('mithril/stream')
var modal = require('./modal');
var key = require('../../libs/keybindings');
var alerts = require('./alerts');
var moveElementModal = require('../../dashboards/components/moveElementModal');
var copyModal = require('../../dashboards/components/copyElementOrDatasetModal');

var RECYCLE_DELETE_CLASSES = ['Site', 'Building', 'Level', 'Room', 'Equipment'];

function isRecycleDeleteRecord(record) {
  return record && RECYCLE_DELETE_CLASSES.indexOf(record['@class']) !== -1;
}

function deleteTitle(record) {
  if (record && record.customDeleteTitle) return record.customDeleteTitle;
  var name = record && (record.name || record['@class']) || 'record';
  if (isRecycleDeleteRecord(record)) {
    return 'Move ' + name + ' and its contents to Recycle Bin?';
  }
  return `Delete ${name} ?`;
}

function deleteErrorMessage(error) {
  if (typeof error === 'string') return error;
  if (error && typeof error.error === 'string') return error.error;
  if (error && typeof error.message === 'string') return error.message;
  return 'Delete failed';
}

function modalTitle(obj, record, resolvedName) {
  var modalRecord = record || {};
  var titleText = modalRecord.customModalTitle
    ? modalRecord.customModalTitle
    : modalRecord['@rid']
      ? `Modify ${resolvedName}`
      : `Create New ${resolvedName}`;

  return typeof obj.modalTitle === 'function' ? obj.modalTitle(titleText, modalRecord) : titleText;
}

function edgeRecordWithChildEndpoint(edgeRecord, childRecord) {
  if (!edgeRecord || edgeRecord.in || !childRecord || !childRecord['@rid']) return edgeRecord;
  return Object.assign({}, edgeRecord, {in: childRecord['@rid']});
}

var modalForm = function (obj) {
  obj.editDialogue = function (record, options) {
    obj.initForm(record, options);
    var submit = async function () {
      document.getElementById('modal-id-to-focus').focus();
      await new Promise((resolve) => setTimeout(resolve, 0));

      return obj.save()
      .then(function (data) {
        if (obj.noAutoClose) {
          return data;
        }
        key.unbind('enter');
        var callbackResult = options && options.submitCallback ? options.submitCallback() : null;
        return Promise.resolve(callbackResult).then(function () {
          modal.vm.close();
          m.redraw();
          return data;
        });
      })
    };

    var deleteSubmit = function () {
      return obj.delete(record)
      .then(function (data) {
        key.unbind('enter')
        options && options.submitCallback ? options.submitCallback() : '';
        modal.vm.close();
      })
    };

    key.setScope('modal');
    key('enter', 'modal', submit);

    var isDatasetRepresentation = record && record.datasetRepresentation;
    var resolvedName = isDatasetRepresentation ? 'Element' : obj.name;

    modal.vm.title(modalTitle(obj, record, resolvedName));

    modal.vm.body = obj.view.bind(obj);
    modal.vm.buttons([
      {
        label: "Submit",
        class: "dib ",
        func: submit
      }
    ])
    
    options && options.delete ? modal.vm.buttons().unshift({
      label: "Delete",
      class: "dib mr2 red ",
      func: () => { 
        delete options.submitCallback;
        obj.deleteDialogue(record, options)
      }
    }) : null;

    options && options.move ? modal.vm.buttons().unshift({
      label: "Move",
      class: "dib mr2",
      func: ()=>{
        modal.vm.close();
        if (record.in_Contains) {
          moveElementModal.editDialogue(edgeRecordWithChildEndpoint(record.in_Contains[0], record), {submitCallback: options.dashboardCallback});
        }
        if (record.in_hasElement) {
          moveElementModal.editDialogue(edgeRecordWithChildEndpoint(record.in_hasElement[0], record), {submitCallback: options.dashboardCallback});
        }
      }
    }) : null;
    
    record && (record['@class'] === 'Element' || record['@class'] === 'Dataset') && record.parent && record.parent['@class'] ? modal.vm.buttons().unshift({
      label: "Copy",
      class: "dib mr2",
      func: () => {
        modal.vm.close();
        copyModal.editDialogue(record, {submitCallback: options.dashboardCallback});
      }
    }) : null;

    var openOptions = {};
    if (obj.extrawidth) {
      openOptions.extrawidth = true;
    }
    if (options && options.extrawidth) {
      openOptions.extrawidth = true;
    }
    if (typeof obj.pointUpdateSuppressionRids === 'function') {
      openOptions.suppressPointUpdates = obj.pointUpdateSuppressionRids(record, options);
    }
    modal.vm.open(openOptions);
  }

  obj.deleteDialogue = function (record, options) {
    obj.initForm(record, options);
    var submit = function () {
      return obj.delete(record)
      .then(function (data) {
        options && options.dashboardCallback ? options.dashboardCallback() : '';
        key.unbind('enter')
        modal.vm.close();
      })
      .catch(function (error) {
        alerts.vm.add({detail: deleteErrorMessage(error)});
        m.redraw();
        return null;
      })
    };
    
    key.setScope('modal');
    key('enter', 'modal', submit);


    obj.initForm(record);

    modal.vm.title(deleteTitle(record));
    modal.vm.buttons([
      {
        label: isRecycleDeleteRecord(record) ? "Move to Recycle Bin" : "Submit",
        class: "btn-good",
        func: submit
      }
    ])
    modal.vm.body = prop("");
    modal.vm.open();
  };

  return obj;
}

module.exports = modalForm;
